/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedYieldResponse } from '../../models/planned-yield-response';

export interface GetTomorrowsPlannedYield$Params {
  location_id: string;
}

export function getTomorrowsPlannedYield(http: HttpClient, rootUrl: string, params: GetTomorrowsPlannedYield$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedYieldResponse>> {
  const rb = new RequestBuilder(rootUrl, getTomorrowsPlannedYield.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedYieldResponse>;
    })
  );
}

getTomorrowsPlannedYield.PATH = '/locations/{location_id}/energy-forecasts/yield/tomorrow';
